export default "__VITE_ASSET__11e0b91b__"